import SAVE_BANK_ACCOUNT from './saveBankAccount.gql';
import ME from './me.gql';

export { ME, SAVE_BANK_ACCOUNT };
